import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IQuote, IQuoteRo } from "interfaces";
import { RootState } from "../index";

interface FormState {
  quoteIn: Partial<IQuote>;
  quoteOut: Partial<IQuote>;

  email: string | null;
  transferId: string | null;
  transferData: Record<string, any> | null;
  quoteRes: IQuoteRo | null;
  timerExpired: boolean;

  walletAddress: string;
  recipientAddress: string;
  walletAmount: string;
  cicoAuthCheck: boolean;
  sidebarClick: string;
  closePay: string | boolean;

  selectedCoinAmount: string | number;
  txHash: string;
  newTransferId: string | null;
}

const initialState: FormState = {
  quoteIn: {
    fiatType: "ngn",
    cryptoType: "btc",
  },
  quoteOut: {
    fiatType: "ngn",
    cryptoType: "btc",
  },

  email: null,
  transferId: null,
  transferData: null,
  quoteRes: null,
  timerExpired: false,

  walletAddress: '',
  walletAmount: '',
  cicoAuthCheck: false,
  sidebarClick: '',
  closePay: '',
  selectedCoinAmount: '',
  recipientAddress: '',
  txHash: '',
  newTransferId: ''
};

interface ISetQuoteDto extends IQuote {
  type: "in" | "out";
  email?: string;
}

const formSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setQuote(state, action: PayloadAction<Partial<ISetQuoteDto>>) {
      const { type, ...payload } = action.payload;
      if (type === "in") state.quoteIn = { ...payload };
      if (type === "out") state.quoteOut = { ...payload };
    },

    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setTransferId(state, action: PayloadAction<string>) {
      state.transferId = action.payload;
    },
    setTransferData(state, action: PayloadAction<Record<string, any>>) {
      state.transferData = action.payload;
    },
    setQuoteRes(state, action: PayloadAction<IQuoteRo>) {
      state.quoteRes = action.payload;
    },
    setTimerExpire(state, { payload }: PayloadAction<boolean>) {
      state.timerExpired = payload;
    },

    // cico
    setWalletAddress: (state, { payload }) => {
      state.walletAddress = payload;
    },
    setRecipientAddress: (state, { payload }) => {
      state.recipientAddress = payload;
    },

    setWalletAmount: (state, { payload }) => {
      state.walletAmount = payload;
    },

    setTxHash: (state, { payload }) => {
      state.txHash = payload;
    },

    setSelectedCoinAmount: (state, { payload }) => {
      state.selectedCoinAmount = payload;
    },

    setCicoAuthCheck: (state, { payload }) => {
      state.cicoAuthCheck = payload;
    },

    sidebarTabClick: (state, { payload }) => {
      state.sidebarClick = payload;
    },

    closePay: (state, { payload }) => {
      state.closePay = payload;
    },

    setNewTransferId: (state, { payload }) => {
      state.newTransferId = payload;
    },
  },
});

export const selectForm = (state: RootState) => state.form;
export const { actions, reducer: FormReducer } = formSlice;
export const {
  setQuote,
  setEmail,
  setQuoteRes,
  setTransferId,
  setTransferData,
  setTimerExpire,
  setWalletAddress,
  setRecipientAddress,
  setCicoAuthCheck,
  sidebarTabClick,
  closePay,
  setWalletAmount,
  setSelectedCoinAmount,
  setTxHash,
  setNewTransferId
} = actions;
